// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/app2.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
    display: flex;
    height: 100vh;
    font-family: 'Poppins', sans-serif;
  }
   
  .left-section {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center center; 
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    color: rgb(0, 0, 0);
    padding: 20px;
    min-height: 100vh;
}

.left-section h4 {
    font-weight: bold;
    margin-bottom: 10px;
    margin-top: 10px; 
}
   
  .left-section h6 {
    margin-bottom: 20px;
  }
   
  .signup-button {
    margin-top: 10px;
    margin-bottom: 10px;
    background-color: #007bff;
    color: white;
    text-transform: none;
    padding: 10px 20px;
    border-radius: 5px;
  }
   
  .signup-button:hover {
    background-color: #0056b3;
  }
   
  .left-section p {
    font-size: 14px;
    color: #333;
  }
   
  .right-section {
    flex: 1 1;
    background-color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px;
    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);
  }
   
  .logo {
    width: 100px;
    margin-bottom: 20px;
  }
   
  form {
    width: 100%;
    max-width: 300px;
    margin-top: 20px;
  }
   
  .login-button {
    width: 100%;
    margin-top: 20px;
    background-color: #007bff;
    color: white;
    text-transform: none;
    padding: 10px;
    border-radius: 5px;
  }
   
  .login-button:hover {
    background-color: #0056b3;
  }
   
  .error-message {
    margin-top: 10px;
    color: red;
    font-size: 14px;
    text-align: center;
  }
   
  a {
    color: #007bff;
    text-decoration: none;
  }
   
  a:hover {
    text-decoration: underline;
  }


  .left-section-footer {
    position: absolute;
    bottom: 20px; /* Distância do fundo */
    left: 50%; /* Centraliza horizontalmente */
    transform: translateX(-50%); /* Ajusta o centro */
    text-align: center;
    backdrop-filter: blur(5px); /* Efeito de blur no fundo */
    background-color: rgba(255, 255, 255, 0.6); /* Fundo semitransparente */
    padding: 10px 20px; /* Espaçamento interno */
    border-radius: 10px; /* Bordas arredondadas */
    font-size: 14px;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,yDAAyC;IACzC,sBAAsB;IACtB,kCAAkC;IAClC,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;EAEE;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,SAAO;IACP,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;;;EAGA;IACE,kBAAkB;IAClB,YAAY,EAAE,uBAAuB;IACrC,SAAS,EAAE,+BAA+B;IAC1C,2BAA2B,EAAE,oBAAoB;IACjD,kBAAkB;IAClB,0BAA0B,EAAE,4BAA4B;IACxD,0CAA0C,EAAE,2BAA2B;IACvE,kBAAkB,EAAE,wBAAwB;IAC5C,mBAAmB,EAAE,wBAAwB;IAC7C,eAAe;EACjB","sourcesContent":[".container {\n    display: flex;\n    height: 100vh;\n    font-family: 'Poppins', sans-serif;\n  }\n   \n  .left-section {\n    background-image: url('/public/app2.jpg');\n    background-size: cover;\n    background-position: center center; \n    background-repeat: no-repeat;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: center;\n    position: relative;\n    color: rgb(0, 0, 0);\n    padding: 20px;\n    min-height: 100vh;\n}\n\n.left-section h4 {\n    font-weight: bold;\n    margin-bottom: 10px;\n    margin-top: 10px; \n}\n   \n  .left-section h6 {\n    margin-bottom: 20px;\n  }\n   \n  .signup-button {\n    margin-top: 10px;\n    margin-bottom: 10px;\n    background-color: #007bff;\n    color: white;\n    text-transform: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n  }\n   \n  .signup-button:hover {\n    background-color: #0056b3;\n  }\n   \n  .left-section p {\n    font-size: 14px;\n    color: #333;\n  }\n   \n  .right-section {\n    flex: 1;\n    background-color: white;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 40px;\n    box-shadow: -2px 0 5px rgba(0, 0, 0, 0.1);\n  }\n   \n  .logo {\n    width: 100px;\n    margin-bottom: 20px;\n  }\n   \n  form {\n    width: 100%;\n    max-width: 300px;\n    margin-top: 20px;\n  }\n   \n  .login-button {\n    width: 100%;\n    margin-top: 20px;\n    background-color: #007bff;\n    color: white;\n    text-transform: none;\n    padding: 10px;\n    border-radius: 5px;\n  }\n   \n  .login-button:hover {\n    background-color: #0056b3;\n  }\n   \n  .error-message {\n    margin-top: 10px;\n    color: red;\n    font-size: 14px;\n    text-align: center;\n  }\n   \n  a {\n    color: #007bff;\n    text-decoration: none;\n  }\n   \n  a:hover {\n    text-decoration: underline;\n  }\n\n\n  .left-section-footer {\n    position: absolute;\n    bottom: 20px; /* Distância do fundo */\n    left: 50%; /* Centraliza horizontalmente */\n    transform: translateX(-50%); /* Ajusta o centro */\n    text-align: center;\n    backdrop-filter: blur(5px); /* Efeito de blur no fundo */\n    background-color: rgba(255, 255, 255, 0.6); /* Fundo semitransparente */\n    padding: 10px 20px; /* Espaçamento interno */\n    border-radius: 10px; /* Bordas arredondadas */\n    font-size: 14px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
